<template>
  <div
    class="wf-product-tiles"
    v-if="this.coordinatingProducts.length > 0"
    :class="
      'wf-product-tiles-view-mode-' +
        viewMode +
        ' wf-product-tiles-tile-size-' +
        tileSize +
        ' wf-product-tiles-display-mode-' +
        displayMode
    "
  >
    <section class="section-content">
      <div class="container-fluid">
        <div class="section-content-top">
          <h2 class="secondary-heading">
            <slot name="title">{{ title }}</slot>
          </h2>
          <slot name="learn-more-link"> </slot>
        </div>

        <div
          :class="
            displayMode === 'slider'
              ? ['wf-product-tiles-slider', 'scroll-fade-right']
              : 'wf-product-tiles-grid'
          "
        >
          <slot name="items">
            <div
              v-for="tile in coordinatingProducts"
              :key="tile.coordinatingProductID"
              class="wf-product-tile wf-product-tile-coordinating-product description"
            >
              <div class="wf-product-tile-image">
                <div class="wf-product-tile-image-swatch">
                  <img
                    class="image "
                    :src="
                      getThumbnailImageUrl(tile.styleNumber, tile.colorNumber)
                    "
                    alt=""
                  />
                </div>
              </div>
              <div class="wf-product-tile-content">
                <div class="wf-product-tile-title">
                  <a
                    :href="
                      getProductDetailUrl(
                        tile.styleNameURL,
                        tile.styleNumber,
                        tile.colorNumber
                      )
                    "
                    class="stretched-link cart-item-model-no"
                  >
                    {{ tile.colorName }} {{ tile.colorNumber }}
                  </a>
                </div>
                <ul class="wf-product-tile-details">
                  <li>
                    {{ tile.productType }}
                  </li>
                  <li>{{ tile.styleName }} {{ tile.styleNumber }}</li>
                  <li
                    v-if="
                      tile.collectionCode && tile.collectionCode.description
                    "
                  >
                    {{ tile.collectionCode.description }} collection
                  </li>
                  <li>{{ tile.customColorCount }} swatch colors</li>
                </ul>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: [
    "defaultTileSize",
    "displayMode",
    "sellingStyleNumber",
    "title",
    "coordinatingItems"
  ],
  created() {
    if (this.defaultTileSize) {
      this.setTileSize(this.defaultTileSize);
    }

    this.setCoordinatingProducts({
      coordinatingProducts: this.coordinatingItems,
      sellingStyleNumber: this.sellingStyleNumber
    });
  },
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color",
      viewMode: "filters/viewMode",
      tileSize: "filters/tileSize",
      coordinatingProducts: "productDetail/coordinatingProducts"
    })
  },
  methods: {
    ...mapActions({
      setTileSize: "filters/setTileSize",
      setCoordinatingProducts: "productDetail/setCoordinatingProducts"
    }),
    getThumbnailImageUrl(styleNumber, colorNumber) {
      let url = this.$helpers.getColorThumbnailImageUrl(
        styleNumber,
        colorNumber
      );
      return url;
    },
    getProductDetailUrl(styleNameURL, styleNumber, colorNumber) {
      return this.$helpers.getProductDetailUrl(
        styleNameURL,
        styleNumber,
        colorNumber
      );
    }
  }
};
</script>
